import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
  Select,
  MenuItem,
  TextField,
  Paper,
  TableContainer,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Tooltip,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import SearchIcon from "@material-ui/icons/Search";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import { AddBox as AddIcon } from "@material-ui/icons";
import GetAppIcon from "@material-ui/icons/GetApp";

/* ------------------------- Importaciones internas ------------------------- */
import { api } from "../../../../services/api";
import { aNumero } from "../../../../core/utils/formatNumATexto";
import { cancelButton, saveButton } from "../../../../core/styles/ui.constants";
import { checkField } from "../../../../core/utils/constantes";
import { handleFile } from "../../../../core/utils/file";
import { useLoading } from "../../../../contexts/LoadingContext";
import { generarHtmlCorreo } from "../../../../core/utils/email/correoTemplate";
import { enviarCorreo } from "../../../../core/utils/email/correo";
import ModalSeguimiento from "./createSeguimiento";
import IngresarComprobanteModal from "./ingresarComprobante";
import FirmaComprobanteModal from "./FirmaComprobanteModal";
import AgregarItemsModal from "./itemsModal";
import BotonGenerico from "../../../../components/Button/Button";
import DialogFooter from "../../../../components/DialogFooter/DialogActions";
import ABMProveedorModal from "./createProveedores";
import { ADMINISTRACION, ADMINISTRADOR, DIRECTOR, GENERAL, TRANSFERENCIA } from "@/core/utils/roles.constants";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
  },
  title: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  titleText: {
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  formRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2), // Agregar espacio entre los elementos
  },
  halfField: {
    width: "49%",
  },
  areaBlanca: {
    backgroundColor: "#f5f5f5",
    padding: theme.spacing(2),
  },
  sectorField: {
    width: "32%", // Ajustar el ancho para que los campos tengan espacio
  },
  conceptoField: {
    width: "32%",
  },
  dateField: {
    width: "32%",
  },
  field: {
    width: "100%", // Ajuste para que los campos no se monten
    fontSize: "0.6rem", // Tamaño de fuente moderado
    textTransform: "none",
    marginBottom: theme.spacing(1), // Espacio entre campos en la misma fila
  },
  table: {
    marginTop: theme.spacing(2),
  },
  icon: {
    color: theme.palette.error.main,
  },
  statusIcon: {
    color: theme.palette.success.main,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  actionButton: saveButton,
  cancelButton: cancelButton,
}));

/**
 * Si estado
 *   --> 0 = Borrador
 *   --> 1 = Enviar a aprobación
 *   --> 2 = Aprobado
 *   --> 3 = Rechazado
 *   --> 4 = Validado
 */

const OrdenServicios = ({
  open,
  onClose,
  onSuccess,
  osDetails,
  listaPersonal,
  listaSector,
  usuarioLocal,
  onAddProveedor,
}) => {
  const classes = useStyles();
  const { show, hide } = useLoading();

  const [OS, setOS] = useState(osDetails);
  const [openSeg, setOpenSeg] = useState(false);
  const [openComprobante, setOpenComprobante] = useState(false);

  const [seguimiento, setSeguimiento] = useState([]);
  const [comprobantes, setComprobantes] = useState([]);

  const [originalSeguimiento, setOriginalSeguimiento] = useState([]);
  const [originalComprobantes, setOriginalComprobantes] = useState([]);
  const [originalItems, setOriginalItems] = useState([]);

  const [tipoComprobante, setTipoComprobante] = useState([]);
  const [comprobanteSelected, setComprobanteSelected] = useState(null);
  const [comprobanteSelectedIndex, setComprobanteSelectedIndex] = useState(
    null
  );

  const fileInputRef = useRef(null);
  const informeInputRef = useRef(null);
  const comprobanteTransferenciaInputRef = useRef(null);

  const [personalOS, setPersonalOS] = useState([]);

  const [currency, setCurrency] = useState("");
  const [items, setItems] = useState([]);
  const [importeTotal, setImporteTotal] = useState(0);
  const [tipoDeCambio, setTipoDeCambio] = useState(1);
  const [observacionRechazo, setObservacionRechazo] = useState("");
  const [openObservacion, setOpenObservacion] = useState(false);
  const [openEliminarComprobante, setOpenEliminarComprobante] =
    useState(false);
  const [comprobanteAEliminar, setComprobanteAEliminar] = useState(null);

  const initialState = {
    fecha: new Date().toISOString().split("T")[0], // Fecha de creación
    fechaEntrega: new Date().toISOString().split("T")[0], // Fecha de entrega
    plazoEntrega: new Date().toISOString().split("T")[0], // Plazo de entrega
    sector: "",
    solicitante: "",
    codigoPresupuesto: "",
    moneda: "ARS", // Puede tener un valor por defecto
    tipoMoneda: "", // Solo se usa cuando moneda es USD
    importeTotal: "",
    observacionRechazo: "",
    diasHabiles: 15,
  };

  const [state, setState] = useState(initialState);
  const [errors, setErrors] = useState({});

  const [openFirma, setOpenFirma] = useState(false);

  const [editable, setEditable] = useState(false);
  const [ordenOriginal, setOrdenOriginal] = useState(null);
  const [openItemsModal, setOpenItemsModal] = useState(false);
  const [itemModalData, setItemModalData] = useState(null);
  const [itemModalIndex, setItemModalIndex] = useState(null);

  const [openProveedor, setOpenProveedor] = useState(false);
  const [openEliminarComprobanteTransferencia, setOpenEliminarComprobanteTransferencia] = useState(false);
  const [comprobanteTransferenciaAEliminar, setComprobanteTransferenciaAEliminar] = useState(null);

  useEffect(() => {
    if (open) {
      setOS(osDetails);
      // console.log("OS", osDetails);
      const fetchData = async () => {
        try {
          // 1. Traer relaciones desde itemsOS
          const itemsOSResponse = await api.itemsOS.getAll();
          const filteredItemsOS = itemsOSResponse.filter(
            (item) => item.idOrdenServicio === osDetails.idOS
          );

          // 2. Extraer ids de los items
          // const itemIds = filteredItemsOS
          //   .map((item) => item.idItemsOS)
          //   .filter((id) => id !== undefined && id !== null);

          // 3. Traer cada item de forma individual
          // const itemsResponse = await Promise.all(
          //   itemIds.map((id) => api.items.getById(id))
          // );

          // 4. Unir itemOS + item => guardar en setItems
          // const itemsCombinados = filteredItemsOS.map((itemOS) => {
          //   // const item = itemsResponse.find((i) => i.id === itemOS.IdItems);
          //   return {
          //     ...itemOS,
          //     // item: item || null,
          //   };
          // });

          setItems(filteredItemsOS); // 👉 Guardamos el array combinado directamente
          setOriginalItems(filteredItemsOS);

          const subtotal = filteredItemsOS.reduce((acc, item) => {
            const precio = parseFloat(item.precioUnitario);
            const cant = parseFloat(item.cantidad);
            if (isNaN(precio) || isNaN(cant)) return acc;
            return acc + precio * cant;
          }, 0);

          const tipoCambio = osDetails.tipoDeCambio || 1;
          const totalConvertido = subtotal * tipoCambio;

          setImporteTotal(formatearImporte(totalConvertido));
          setTipoDeCambio(tipoCambio);
          setCurrency(osDetails.moneda);

          const toDate = (v) => v ? v.split("T")[0] : "";

          setState({
            fecha: toDate(osDetails.FechaCreacion),
            fechaEntrega: toDate(osDetails.fechaEntrega),
            plazoEntrega: toDate(osDetails.plazoEntrega),
            sector: osDetails.idSector,
            solicitante: osDetails.IdUsuario ? String(osDetails.IdUsuario) : "",
            codigoPresupuesto: osDetails.codigoPresupuesto || "",
            moneda: osDetails.moneda,
            tipoMoneda: osDetails.tipoMoneda || "",
            importeTotal: totalConvertido.toFixed(2),
            observacionRechazo: osDetails.observacionRechazo,
            diasHabiles: osDetails.diasHabiles ?? 15,
          });

          setOrdenOriginal({
            fecha: toDate(osDetails.FechaCreacion),
            fechaEntrega: toDate(osDetails.fechaEntrega),
            plazoEntrega: toDate(osDetails.plazoEntrega),
            sector: osDetails.idSector,
            solicitante: osDetails.IdUsuario ? String(osDetails.IdUsuario) : "",
            codigoPresupuesto: osDetails.codigoPresupuesto || "",
            moneda: osDetails.moneda,
            tipoMoneda: osDetails.tipoMoneda || "",
            importeTotal: totalConvertido.toFixed(2),
            observacionRechazo: osDetails.observacionRechazo,
            diasHabiles: osDetails.diasHabiles ?? 15,
          });

          await obtenerPersonal();
          await obtenerTipoComprobante();
          await obtenerSeguimiento(osDetails.idOS);
          await obtenerComprobantes(osDetails.idOS);
        } catch (error) {
          console.error("Error al obtener items relacionados:", error);
        }
      };

      fetchData();
    } else {
      setEditable(false);
    }
  }, [open]);

  const isAdmin = usuarioLocal?.es_admin === ADMINISTRADOR;
  const isDirector = usuarioLocal?.es_admin === DIRECTOR;
  const isGeneral = usuarioLocal?.es_admin === GENERAL;
  const isTransferencia = usuarioLocal?.es_admin === TRANSFERENCIA;
  const isAdministracion = usuarioLocal?.es_admin === ADMINISTRACION;

  // Puede habilitar modo edición según rol y estado de la OS
  const canEnable = osDetails && (
    isAdmin ||
    !isGeneral ||
    (isTransferencia && checkField(osDetails, "estadoOS", 5)) ||
    (isDirector && checkField(osDetails, "estadoOS", 6)) ||
    (isAdministracion && checkField(osDetails, "estadoOS", 7))
  ) && !checkField(osDetails, "estadoOS", 3);
  // const canEnable = osDetails && (
  //   ((checkField(osDetails, "estadoOS", 1) || checkField(osDetails, "estadoOS", 4))) ||
  //   checkField(osDetails, "estadoOS", 5) || checkField(osDetails, "estadoOS", 6) || checkField(osDetails, "estadoOS", 7)
  // ) && !checkField(osDetails, "estadoOS", 3);


  // Solo Admin y General pueden editar los campos del formulario
  // const camposEditables = isAdmin || isGeneral;
  // const canEditBudget = isAdmin || isAdministracion;


  // Puede eliminar items según rol y estado de la OS
  // const canDeleteItems = editable && (
  //   isAdmin ||
  //   (isGeneral && (checkField(osDetails, "estadoOS", 1) || checkField(osDetails, "estadoOS", 4))) ||
  //   (isTransferencia && checkField(osDetails, "estadoOS", 5)) ||
  //   (isDirector && checkField(osDetails, "estadoOS", 6))
  // );
  const canDeleteItems = editable && (
    checkField(osDetails, "estadoOS", 1) || checkField(osDetails, "estadoOS", 4) ||
    checkField(osDetails, "estadoOS", 5) || checkField(osDetails, "estadoOS", 6)
  );

  const recalculateItemsTotal = (itemsList, selectedCurrency = currency, selectedTipoDeCambio = tipoDeCambio) => {
    const subtotal = itemsList.reduce((acc, item) => {
      const precio = parseFloat(item.precioUnitario || 0);
      const cant = parseFloat(item.cantidad || 0);
      if (isNaN(precio) || isNaN(cant)) return acc;
      return acc + precio * cant;
    }, 0);

    const total = selectedCurrency === "USD" ? subtotal * selectedTipoDeCambio : subtotal;
    setImporteTotal(formatearImporte(total));
    return total;
  };

  const handleCloseProveedor = () => setOpenProveedor(false);

  // Funciones para Comprobante de Transferencia
  const handleComprobanteTransferenciaClick = () => {
    if (comprobanteTransferenciaInputRef.current) {
      comprobanteTransferenciaInputRef.current.click();
    }
  };

  const handleAdjuntarComprobanteTransferencia = async (e) => {
    const file = e.target.files?.[0];
    const input = e.target;

    if (!file) return;

    try {
      const result = await handleFile(file, { readOnly: true });

      const nuevoComprobante = {
        idOS: osDetails.idOS,
        fechaCreacion: new Date().toISOString().split("T")[0],
        fechaInicio: new Date().toISOString().split("T")[0],
        idUsuario: usuarioLocal.IdUsuario || usuarioLocal.id,
        observaciones: "Comprobante de transferencia adjunto",
        observacion: "Comprobante de transferencia adjunto",
        usuario: `${usuarioLocal.Nombre} ${usuarioLocal.Apellido}`,
        archivoFile: result.file,
        adjunto: "",
        esComprobanteTransferencia: true
      };

      setSeguimiento((prev) => {
        const indiceExistente = prev.findIndex((s) => s.esComprobanteTransferencia);
        if (indiceExistente !== -1) {
          const copia = [...prev];
          copia[indiceExistente] = { ...copia[indiceExistente], ...nuevoComprobante };
          return copia;
        }
        return [...prev, nuevoComprobante];
      });
    } catch (err) {
      console.error(err);
    } finally {
      if (input) input.value = "";
    }
  };

  const handleEliminarComprobanteTransferencia = (id, index) => {
    setSeguimiento((prev) => {
      let nuevoSeguimiento;

      if (id) {
        nuevoSeguimiento = prev.filter((item) => item.idseguimientoOS !== id);
      } else {
        nuevoSeguimiento = prev.filter((_, i) => i !== index);
      }

      return nuevoSeguimiento;
    });
  };

  const handleOpenEliminarComprobanteTransferencia = (idseguimientoOS, index) => {
    setComprobanteTransferenciaAEliminar({ idseguimientoOS, index });
    setOpenEliminarComprobanteTransferencia(true);
  };

  const handleCloseEliminarComprobanteTransferencia = () => {
    setComprobanteTransferenciaAEliminar(null);
    setOpenEliminarComprobanteTransferencia(false);
  };

  const handleConfirmarEliminarComprobanteTransferencia = () => {
    if (!comprobanteTransferenciaAEliminar) return;

    handleEliminarComprobanteTransferencia(
      comprobanteTransferenciaAEliminar.idseguimientoOS,
      comprobanteTransferenciaAEliminar.index
    );
    handleCloseEliminarComprobanteTransferencia();
  };

  const handleCurrencyChange = (event) => {
    const nuevaMoneda = event.target.value;
    setCurrency(nuevaMoneda);

    const subtotal = items.reduce(
      (acc, item) => acc + parseFloat(item.precioTotal || 0),
      0
    );
    const total = nuevaMoneda === "USD" ? subtotal * tipoDeCambio : subtotal;
    setImporteTotal(total);

    setState((prev) => ({
      ...prev,
      moneda: nuevaMoneda,
      importeTotal: total.toFixed(2), // o mantenerlo como número
    }));
  };

  const formatearImporte = (valor) => {
    const monto = parseFloat(valor || 0).toFixed(2);
    return `$ ${monto}`; // Siempre en ARS
  };

  const handleTipoMonedaChange = (event) => {
    const nuevoTipoMoneda = event.target.value;
    setState((prev) => ({
      ...prev,
      tipoMoneda: nuevoTipoMoneda,
    }));
    setErrors((prev) => ({
      ...prev,
      tipoMoneda: "",
    }));
  };

  const handleEliminarSeguimiento = (id, index) => {
    setSeguimiento((prev) => {
      let nuevaSeguimiento;

      if (id) {
        // Si tiene ID de base de datos, filtrar por ID
        nuevaSeguimiento = prev.filter((item) => item.idseguimientoOS !== id);
      } else {
        // Si no tiene ID (item nuevo), filtrar por índice
        nuevaSeguimiento = prev.filter((_, i) => i !== index);
      }

      return nuevaSeguimiento;
    });
  };

  const handleEliminarComprobante = (idcomprobanteOS, index) => {
    setComprobantes((prev) =>
      prev.filter((item, i) => (item.idcomprobanteOS && item.idcomprobanteOS !== idcomprobanteOS) || i !== index)
    );
  };

  const handleOpenEliminarComprobante = (idcomprobanteOS, index) => {
    setComprobanteAEliminar({ idcomprobanteOS, index });
    setOpenEliminarComprobante(true);
  };

  const handleCloseEliminarComprobante = () => {
    setComprobanteAEliminar(null);
    setOpenEliminarComprobante(false);
  };

  const handleConfirmarEliminarComprobante = () => {
    if (!comprobanteAEliminar) return;

    handleEliminarComprobante(
      comprobanteAEliminar.idcomprobanteOS,
      comprobanteAEliminar.index
    );
    handleCloseEliminarComprobante();
  };

  const handleOpenComprobante = () => setOpenComprobante(true); // Abre el modal de comprobante

  const handleCloseComprobante = () => {
    setOpenComprobante(false);
    setComprobanteSelected(null);
  }; // Cierra el modal de comprobante

  const handleOpenSeg = () => setOpenSeg(true); // Abre el modal de seguimiento
  const handleCloseSegSeguimiento = () => setOpenSeg(false); // Cierra el modal de seguimiento

  // Paso 1: al apretar el botón, abrir el input oculto
  const handleAdjuntoClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Paso 2: al seleccionar el archivo, procesarlo
  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    const input = e.target;
    if (!file) return;

    try {
      const result = await handleFile(file, { readOnly: true });

      setComprobantes((prev) => [
        ...prev,
        {
          estado: 'Pendiente de pago',
          fechaCreacion: new Date().toISOString().split("T")[0],
          fechaComprobante: new Date().toISOString().split("T")[0],
          importe: 0,
          idTipoComprobante: null,
          idUsuario: usuarioLocal.IdUsuario || usuarioLocal.id,
          observaciones: "Archivo agregado por 'Adjunto'",
          archivoFile: result.file,
          archivoColumns: result.columns, // undefined si es PDF
          archivoUrl: result.file,
          nroReferenciaPago: "",
          esAdjunto: true,
          usuario: `${usuarioLocal.Nombre} ${usuarioLocal.Apellido}` // Agregar info del usuario
        },
      ]);
    } catch (err) {
      console.error(err);
    } finally {
      if (input) input.value = "";
    }
  };

  // Adjuntar informe final
  const handleInformeClick = () => {
    if (informeInputRef.current) {
      informeInputRef.current.click();
    }
  };

  const handleAdjuntarInforme = async (e) => {
    const file = e.target.files?.[0];
    const input = e.target;

    if (!file) return;

    try {
      // Solo procesar archivo en memoria, NO subirlo al servidor aún
      const result = await handleFile(file, { readOnly: true });

      // Preparar objeto de informe
      const nuevoInforme = {
        idOS: osDetails.idOS,
        fechaCreacion: new Date().toISOString().split("T")[0],
        fechaInicio: new Date().toISOString().split("T")[0],
        idUsuario: usuarioLocal.IdUsuario || usuarioLocal.id,
        observaciones: "Informe de laboratorio adjunto",
        usuario: `${usuarioLocal.Nombre} ${usuarioLocal.Apellido}`,
        archivoFile: result.file, // Archivo en memoria para subir cuando se guarde
        adjunto: "", // Se llenará cuando se suba al servidor
        esInformeLaboratorio: true // Flag para identificar que es informe de laboratorio
      };

      setSeguimiento((prev) => {
        const indiceExistente = prev.findIndex((s) => s.esInformeLaboratorio);
        if (indiceExistente !== -1) {
          // reemplazar el informe existente
          const copia = [...prev];
          copia[indiceExistente] = { ...copia[indiceExistente], ...nuevoInforme };
          return copia;
        }
        // no había informe anterior, agregar al final
        return [...prev, nuevoInforme];
      });
    } catch (err) {
      console.error(err);
    } finally {
      if (input) input.value = "";
    }
  };

  const handleVerArchivo = (path) => {
    const backendUrl = process.env.REACT_APP_SERVER_URL;
    if (path.toLowerCase().endsWith(".pdf")) {
      window.open(`${backendUrl}${path}`, "_blank"); // abre PDF directamente
    } else {
      fetch(`${backendUrl}${path}`)
        .then((res) => res.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = path.split("/").pop();
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error al obtener archivo", err));
    }
  };

  const handleChange = (field, value) => {
    switch (field) {
      case 'diasHabiles':
        if (value !== "" && (!/^\d+$/.test(value) || Number(value) < 1 || Number(value) > 99)) {
          return;
        }
        break;
    }
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleEliminarItem = (idItemsOS, index) => {
    setItems((prev) => {
      const nextItems = idItemsOS
        ? prev.filter((item) => item.idItemsOS !== idItemsOS)
        : prev.filter((_, i) => i !== index);
      recalculateItemsTotal(nextItems);
      return nextItems;
    });
  };

  const handleEditarItem = (item, index) => {
    setItemModalData({
      ...item,
      precioTotal:
        item.precioTotal ||
        (
          (parseFloat(item.cantidad) || 0) * (parseFloat(item.precioUnitario) || 0)
        ).toFixed(2),
    });
    setItemModalIndex(index);
    setOpenItemsModal(true);
  };

  const handleGuardarItem = (itemEditado) => {
    setItems((prev) => {
      const nextItems =
        itemModalIndex === null
          ? [...prev, itemEditado]
          : prev.map((item, index) =>
            index === itemModalIndex ? { ...item, ...itemEditado } : item
          );
      recalculateItemsTotal(nextItems);
      return nextItems;
    });
    setOpenItemsModal(false);
    setItemModalData(null);
    setItemModalIndex(null);
  };

  const handleCloseItemsModal = () => {
    setOpenItemsModal(false);
    setItemModalData(null);
    setItemModalIndex(null);
  };



  const obtenerPersonal = async () => {
    try {
      const seguimientoResponse = await api.seguimientos.getAll();

      const personal = await Promise.all(
        seguimientoResponse.map(async (item) => {
          if (!item.idUsuario) return null;

          const usuario = await api.usuarios.getById(item.idUsuario);

          return {
            idOS: item.idOS,
            idUsuario: item.idUsuario,
            fechaCreacion: item.fechaCreacion,
            fechaInicio: item.fechaInicio,
            observaciones: item.observaciones,
            usuario: `${usuario.Nombre} ${usuario.Apellido}`,
          };
        })
      );

      setPersonalOS(personal.filter(Boolean));
    } catch (error) {
      console.error("Error al obtener usuarios relacionados:", error);
    }
  };

  const obtenerTipoComprobante = async () => {
    try {
      const tipoComprobante = await api.tipoComprobante.getAll();
      setTipoComprobante(tipoComprobante);
    } catch (error) {
      console.error(
        "Error al obtener los tipos comprobantes relacionados:",
        error
      );
    }
  };

  const obtenerComprobantes = async (idOS) => {
    try {
      const comprobantes = await api.comprobantesOS.getAll();

      const filteredComprobantes = comprobantes
        .filter((c) => c.idOS === idOS)
        .map((c) => ({
          ...c,
          esAdjunto: Boolean(c.adjunto),
        }));

      setComprobantes(filteredComprobantes);
      setOriginalComprobantes(filteredComprobantes);
    } catch (error) {
      console.error("Error al obtener comprobantes relacionados:", error);
    }
  };

  const obtenerSeguimiento = async (idOS) => {
    try {
      const seguimiento = await api.seguimientos.getAll();

      const seguimientoUsuario = await Promise.all(
        seguimiento.map(async (s) => {
          let usuarioStr = null;
          if (s.idUsuario) {
            const usuario = await api.usuarios.getById(s.idUsuario);
            usuarioStr = `${usuario.Nombre} ${usuario.Apellido}`;
          }

          // Detectar si es informe de laboratorio basado en el texto de observaciones y adjunto
          const esInformeLaboratorio = s.adjunto &&
            (s.observacion?.toLowerCase().includes("informe de laboratorio") ||
              s.observacion?.toLowerCase().includes("laboratorio"));

          const esComprobanteTransferencia = s.adjunto &&
            (s.observacion?.toLowerCase().includes("comprobante de transferencia") ||
              s.observacion?.toLowerCase().includes("transferencia"));

          return {
            ...s,
            usuario: usuarioStr,
            observaciones: s.observacion, // Mapear observacion -> observaciones para consistencia en frontend
            esInformeLaboratorio: esInformeLaboratorio,
            esComprobanteTransferencia: esComprobanteTransferencia
          };
        })
      );

      const filteredSeguimiento = seguimientoUsuario.filter(
        (s) => s.idOS === idOS
      );

      setSeguimiento(filteredSeguimiento);
      setOriginalSeguimiento(filteredSeguimiento);
    } catch (error) {
      console.error("Error al obtener seguimiento relacionados:", error);
    }
  };

  const handleSuccessSeguimiento = (nuevoSeguimiento) => {
    let usuario;
    usuario = personalOS.find((p) => p.id === nuevoSeguimiento.idUsuario);

    if (!usuario) {
      usuario = usuarioLocal;
    }

    const nombre = usuario?.Nombre;
    const apellido = usuario?.Apellido;

    const seguimiento = {
      ...nuevoSeguimiento,
      usuario: `${nombre} ${apellido}`,
    };

    setSeguimiento((prev) => [...prev, seguimiento]);
  };

  const handleSuccessComprobante = (nuevoComprobante) => {
    setComprobantes((prev) => {
      if (comprobanteSelected) {
        // 🔹 Si había un comprobante en edición → reemplazo
        return prev.map((c) =>
          c === comprobanteSelected ? { ...c, ...nuevoComprobante } : c
        );
      } else {
        // 🔹 Si no había seleccionado → agrego uno nuevo
        return [...prev, nuevoComprobante];
      }
    });

    // Limpio la selección después de guardar
    setComprobanteSelected(null);
  };

  const handleGuardar = async (estado) => {
    if (estado === 6 && state.moneda === "USD" && !state.tipoMoneda) {
      setErrors((prev) => ({
        ...prev,
        tipoMoneda: "Debe seleccionar Divisa o Billete antes de continuar.",
      }));
      return;
    }

    show("Guardando orden de servicio...");
    try {
      let ordenServicioUpdate;

      // Detectar cambios en seguimiento
      const cambiosSeguimiento = detectarCambios(
        originalSeguimiento,
        seguimiento,
        "idseguimientoOS"
      );

      // Detectar cambios en comprobantes
      const cambiosComprobantes = detectarCambios(
        originalComprobantes,
        comprobantes,
        "idcomprobanteOS"
      );

      // Detectar items eliminados
      const itemsEliminados = originalItems.filter(
        (orig) => !items.some((cur) => cur.idItemsOS === orig.idItemsOS)
      );

      // Insertar nuevos
      for (const item of cambiosSeguimiento.insertados) {
        // Procesar archivo adjunto si existe y no se ha procesado ya
        if (item.archivoFile && !item.adjunto) {
          const result = await handleFile(item.archivoFile);
          item.adjuntoPath = result.path;
        }

        // Crear objeto limpio para enviar al servidor
        const seguimientoAgregar = {
          idOS: item.idOS,
          fechaCreacion: item.fechaCreacion,
          fechaInicio: item.fechaInicio,
          idUsuario: item.idUsuario,
          observacion: item.observaciones, // Mapear observaciones -> observacion
          adjunto: item.adjunto || item.adjuntoPath || "" // Usar adjunto si ya existe, sino adjuntoPath
        };

        await api.seguimientos.create(seguimientoAgregar);
      }

      for (const item of cambiosComprobantes.insertados) {
        if (item.archivoFile) {
          const result = await handleFile(item.archivoFile);
          item.adjuntoPath = result.path;
          item.fechaCreacion = new Date().toISOString().split("T")[0];
          item.estado = "Pendiente de pago";
        }
        const comprobanteAgregar = {
          fechaCreacion: item.fechaCreacion,
          fechaComprobante: item.fechaComprobante,
          cuit: item.cuit,
          sucursal: item.sucursal,
          numero: item.numero,
          observaciones: item.observaciones,
          cantidad: item.cantidad,
          importe: item.importe,
          estado: item.estado,
          fechaPago: item.fechaPago,
          modalidadPago: item.modalidadPago,
          nroReferenciaPago: aNumero(item.nroReferenciaPago),
          idTipoComprobante: item.idTipoComprobante,
          idUsuario: item.idUsuario,
          idOS: OS.idOS,
          adjunto: item.adjuntoPath || "",
        };
        await api.comprobantesOS.create(comprobanteAgregar);
      }

      // Actualizar
      for (const item of cambiosSeguimiento.actualizados) {
        // Procesar archivo adjunto si existe y no se ha procesado ya
        if (item.archivoFile && !item.adjunto) {
          const result = await handleFile(item.archivoFile);
          item.adjuntoPath = result.path;
        }

        // Crear objeto limpio para enviar al servidor
        const seguimientoActualizar = {
          idOS: item.idOS,
          fechaCreacion: item.fechaCreacion,
          fechaInicio: item.fechaInicio,
          idUsuario: item.idUsuario,
          observacion: item.observaciones, // Mapear observaciones -> observacion
          adjunto: item.adjunto || item.adjuntoPath || ""
        };

        await api.seguimientos.update(item.idseguimientoOS, seguimientoActualizar);
      }

      for (const item of cambiosComprobantes.actualizados) {
        if (item.archivoFile) {
          const result = await handleFile(item.archivoFile);
          item.adjunto = result.path;
        }
        await api.comprobantesOS.update(item.idcomprobanteOS, item);
      }

      // Eliminar
      for (const item of cambiosSeguimiento.eliminados) {
        await api.seguimientos.delete(item.idseguimientoOS);
      }

      for (const item of cambiosComprobantes.eliminados) {
        await api.comprobantesOS.delete(item.idcomprobanteOS);
      }

      for (const item of itemsEliminados) {
        if (item.idItemsOS) {
          await api.itemsOS.delete(item.idItemsOS);
        }
      }

      if (estado === 4) {
        ordenServicioUpdate = {
          idOS: OS.idOS,
          estadoOS: estado,
          IdUsuario: state.solicitante || null,
          observacionRechazo: observacionRechazo || state.observacionRechazo,
          plazoEntrega: state.plazoEntrega,
          fechaEntrega: state.fechaEntrega,
          idSector: state.sector,
          codigoPresupuesto: state.codigoPresupuesto,
          moneda: state.moneda,
          tipoMoneda: state.moneda === "USD" ? state.tipoMoneda : null,
          diasHabiles: state.diasHabiles !== "" ? Number(state.diasHabiles) : null,
        };

        await api.ordenesServicios.update(OS.idOS, {
          estadoOS: estado,
          IdUsuario: state.solicitante || null,
          observacionRechazo: observacionRechazo || state.observacionRechazo,
          plazoEntrega: state.plazoEntrega,
          fechaEntrega: state.fechaEntrega,
          idSector: state.sector,
          codigoPresupuesto: state.codigoPresupuesto,
          moneda: state.moneda,
          tipoMoneda: state.moneda === "USD" ? state.tipoMoneda : null,
          diasHabiles: state.diasHabiles !== "" ? Number(state.diasHabiles) : null,
        });
      } else {
        ordenServicioUpdate = {
          idOS: OS.idOS,
          IdUsuario: state.solicitante || null,
          estadoOS: estado,
          fechaEntrega: state.fechaEntrega,
          idSector: state.sector,
          codigoPresupuesto: state.codigoPresupuesto,
          moneda: state.moneda,
          tipoDeCambio: tipoDeCambio,
          importeTotal: state.importeTotal,
          plazoEntrega: state.plazoEntrega,
          tipoMoneda: state.moneda === "USD" ? state.tipoMoneda : null,
          diasHabiles: state.diasHabiles !== "" ? Number(state.diasHabiles) : null,
        };

        const update = {
          estadoOS: estado,
          fechaEntrega: state.fechaEntrega,
          idSector: state.sector,
          codigoPresupuesto: state.codigoPresupuesto,
          moneda: state.moneda,
          tipoDeCambio: tipoDeCambio,
          importeTotal: state.importeTotal,
          IdUsuario: state.solicitante || null,
          plazoEntrega: state.plazoEntrega,
          tipoMoneda: state.moneda === "USD" ? state.tipoMoneda : null,
          diasHabiles: state.diasHabiles !== "" ? Number(state.diasHabiles) : null,
        };

        // Finalmente actualizar estado OS
        await api.ordenesServicios.update(OS.idOS, update);

        if (estado === 6) {
          const usuarios = await api.usuarios.getAll();
          const usuariosAdministracion = usuarios.filter(
            // (u) => u.IdSector === OS.idSector && u.es_admin === 1
            (u) => u.IdSector === OS.idSector
          );

          const correosAdministracion = usuariosAdministracion.map(
            (u) => u.email
          );

          const html = generarHtmlCorreo({
            titulo: "Transferencia aceptó la orden de servicio",
            encabezado: "Transferencia aceptó la orden de servicio",
            cuerpo: `<p>La orden de servicio con Número <strong>${OS.idOS}</strong> fue aceptada por Transferencia.</p>`,
            botonTexto: "Ver Orden de Servicio",
          });

          if (correosAdministracion.length > 0) {
            await enviarCorreo(
              correosAdministracion,
              "Transferencia aceptó la orden de servicio",
              html
            );
          }
        }
      }

      onSuccess(ordenServicioUpdate);
      onClose();
      restart();
    } catch (error) {
      console.error("Error al guardar la orden:", error.message);
      alert("Ocurrió un error al guardar. Intenta nuevamente.");
    } finally {
      hide();
    }
  };

  const restart = () => {
    setOpenSeg(false);
    setOpenComprobante(false);
    setComprobantes([]);
    setSeguimiento([]);
    setState(initialState);
    setErrors({});
    setImporteTotal(0);
    setTipoDeCambio(1);
    setCurrency("");
    setItems([]);
    setOriginalItems([]);
    setComprobanteSelected(null);
  };

  // Función para decidir qué ícono mostrar según idTipoComprobante
  const renderEstadoIcon = (estado) => {
    if (estado === "Pendiente de pago") {
      return (
        <Tooltip title={<span style={{ fontSize: "0.8rem" }}>{estado}</span>}>
          <ErrorIcon color="secondary" />
        </Tooltip>
      );
    }

    return (
      <Tooltip
        title={<span style={{ fontSize: "0.8rem" }}>{estado || ""}</span>}
      >
        <CheckCircleIcon color="primary" />
      </Tooltip>
    );
  };

  const renderTipoComprobante = (idTipoComprobante) => {
    const tipo = tipoComprobante.find(
      (tc) => tc.idtipo_comprobante === idTipoComprobante
    );

    if (!tipo) return "Adjunto";

    return tipo.Nombre || "";
  };

  const firmarComprobante = (row, index) => {
    setComprobanteSelectedIndex(index);
    setOpenFirma(true); // abre modal de confirmación
  };

  const handleFirmaSubmit = (info) => {
    const { estado, fechaPago, modalidadPago, nroReferenciaPago } = info;
    setComprobantes((prev) =>
      prev.map((comp, i) =>
        i === comprobanteSelectedIndex
          ? {
            ...comp,
            estado: estado,
            fechaPago: fechaPago,
            modalidadPago: modalidadPago,
            nroReferenciaPago: nroReferenciaPago,
          }
          : comp
      )
    );

    setOpenFirma(false); // cierra el modal
  };

  const handleModalObservacion = () => {
    setOpenObservacion(true);
  };

  const detectarCambios = (original, actual, key = "id") => {
    const insertados = actual.filter(
      (item) => !original.some((o) => o[key] === item[key])
    );

    const eliminados = original.filter(
      (item) => !actual.some((a) => a[key] === item[key])
    );

    const actualizados = actual.filter((item) =>
      original.some(
        (o) =>
          o[key] === item[key] && JSON.stringify(o) !== JSON.stringify(item)
      )
    );

    return { insertados, eliminados, actualizados };
  };

  // Antes del return
  const mostrarColumnaReferencia = comprobantes.some(
    (c) => c.nroReferenciaPago && c.nroReferenciaPago !== "0"
  );

  const mostrarColumnaOpciones = comprobantes.length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6" className={classes.titleText}>
          Viendo Orden de Servicios Número {OS?.idOS ?? "..."}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {osDetails && (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {canEnable && (
              <Tooltip
                title={
                  <span style={{ fontSize: "0.8rem" }}>
                    {editable ? "Cancelar edición" : "Habilitar edición"}
                  </span>
                }
              >
                <IconButton
                  onClick={() => {
                    if (editable) {
                      const subtotal = items.reduce((acc, item) => {
                        const precio = parseFloat(item.precioUnitario);
                        const cant = parseFloat(item.cantidad);
                        if (isNaN(precio) || isNaN(cant)) return acc;
                        return acc + precio * cant;
                      }, 0);

                      const tipoCambio = ordenOriginal.tipoDeCambio || 1;
                      const totalConvertido = subtotal * tipoCambio;

                      setImporteTotal(formatearImporte(totalConvertido));
                      setTipoDeCambio(tipoCambio);
                      setCurrency(ordenOriginal.moneda);

                      setState({
                        fecha: ordenOriginal.FechaCreacion,
                        fechaEntrega: ordenOriginal.fechaEntrega,
                        plazoEntrega: ordenOriginal.plazoEntrega,
                        sector: ordenOriginal.sector,
                        solicitante: ordenOriginal.solicitante || "",
                        codigoPresupuesto: ordenOriginal.codigoPresupuesto || "",
                        moneda: ordenOriginal.moneda,
                        tipoMoneda: ordenOriginal.tipoMoneda || "",
                        importeTotal: ordenOriginal.importeTotal,
                        observacionRechazo: ordenOriginal.observacionRechazo,
                        diasHabiles: ordenOriginal.diasHabiles ?? 15,
                      });
                    }
                    setEditable(!editable);
                  }}
                >
                  {editable ? <CloseIcon /> : <EditIcon />}
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}
        <div className={classes.formRow}>
          <div className={classes.halfField}>
            <Typography variant="subtitle1">
              Sector <span className="text-danger">*</span>
            </Typography>
            <Select
              variant="outlined"
              fullWidth
              defaultValue=""
              value={state.sector || ""}
              onChange={(e) => handleChange("sector", e.target.value)}
              // disabled={!editable || !camposEditables}
              disabled={!editable}
              error={!!errors.sector || undefined}
            >
              {listaSector.map((sector) => (
                <MenuItem key={sector.IdSector} value={sector.IdSector}>
                  {sector.Nombre}
                </MenuItem>
              ))}
            </Select>
            {errors.sector && (
              <Typography color="error" variant="body2">
                {errors.sector}
              </Typography>
            )}
          </div>
          <div className={classes.halfField}>
            <ABMProveedorModal
              open={openProveedor}
              onClose={handleCloseProveedor}
              onSuccess={onAddProveedor}
              tipoCliente="cliente"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle1">
                Cliente <span className="text-danger">*</span>
              </Typography>
              {editable && (
                <Tooltip
                  title={
                    <span style={{ fontSize: "0.8rem" }}>Agregar cliente</span>
                  }
                  arrow
                >
                  <IconButton
                    color="primary"
                    onClick={() => setOpenProveedor(true)}
                    size="small"
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              )}
            </div>
            <Select
              variant="outlined"
              fullWidth
              defaultValue=""
              value={state.solicitante || ""}
              onChange={(e) => handleChange("solicitante", e.target.value)}
              error={!!errors.solicitante || undefined}
              // disabled={!editable || !camposEditables}
              disabled={!editable}
            >
              {editable
                ? listaPersonal
                  .filter(
                    (p) =>
                      p.Rol === "cliente" &&
                      p.Estado === "activo" &&
                      !p.oculto
                  )
                  .map((personal) => (
                    <MenuItem
                      key={personal.idProveedor}
                      value={String(personal.idProveedor)}
                    >
                      {personal.ApellidoyNombre}
                    </MenuItem>
                  ))
                : listaPersonal.map((personal) => (
                  <MenuItem
                    key={personal.idProveedor}
                    value={String(personal.idProveedor)}
                  >
                    {personal.ApellidoyNombre}
                  </MenuItem>
                ))}
            </Select>
            {errors.solicitante && (
              <Typography color="error" variant="body2">
                {errors.solicitante}
              </Typography>
            )}
          </div>
        </div>
        <div className={classes.formRow}>
          <div className={classes.halfField}>
            <Typography variant="subtitle1">Codigo de presupuesto</Typography>
            <TextField
              variant="outlined"
              fullWidth
              value={state.codigoPresupuesto || ""}
              onChange={(e) => handleChange("codigoPresupuesto", e.target.value)}
              // disabled={!editable || !canEditBudget}
              disabled={!editable}
            />
          </div>
          <div className={classes.halfField}>
            <Typography variant="subtitle1">Días hábiles</Typography>
            <TextField
              variant="outlined"
              type="text"
              inputMode="numeric"
              fullWidth
              value={state.diasHabiles ?? ""}
              onChange={(e) => handleChange("diasHabiles", e.target.value)}
              // disabled={!editable || !camposEditables}
              disabled={!editable}
              inputProps={{ pattern: "[0-9]*" }}
            />
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.halfField}>
            <Typography variant="subtitle1">
              Fecha de Entrega <span className="text-danger">*</span>
            </Typography>
            <TextField
              variant="outlined"
              type="date"
              fullWidth
              value={state.fechaEntrega}
              onChange={(e) => handleChange("fechaEntrega", e.target.value)}
              // disabled={!editable || !camposEditables}
              disabled={!editable}
            />
          </div>
          <div className={classes.halfField}>
            <Typography variant="subtitle1">
              Plazo de Entrega <span className="text-danger">*</span>
            </Typography>
            <TextField
              variant="outlined"
              type="date"
              fullWidth
              value={state.plazoEntrega}
              onChange={(e) => handleChange("plazoEntrega", e.target.value)}
              // disabled={!editable || !camposEditables}
              disabled={!editable}
            />
          </div>
        </div>

        {/* Fila de ARS / USD, Importe y Fecha de Entrega */}
        <div className={classes.formRow}>
          <div
            style={{
              width: "26%",
            }}
          >
            <FormControl
              component="fieldset"
              className={classes.radioGroup}
              // disabled={!editable || !camposEditables}
              disabled={!editable}
            >
              <FormLabel component="legend">
                Moneda <span className="text-danger">*</span>
              </FormLabel>
              <RadioGroup
                row
                value={currency}
                onChange={handleCurrencyChange}
                error={!!errors.moneda || undefined}
              >
                <FormControlLabel value="ARS" control={<Radio />} label="ARS" />
                <FormControlLabel value="USD" control={<Radio />} label="USD" />
              </RadioGroup>
            </FormControl>
            {errors.moneda && (
              <Typography color="error" variant="body2">
                {errors.moneda}
              </Typography>
            )}
          </div>
          {currency === "USD" &&
            !checkField(osDetails, "estadoOS", 0) && (
              <>
                <div style={{ width: "32%" }}>
                  <Typography style={{ marginBottom: 4 }} variant="subtitle1">
                    Tipo de Cambio (ARS a USD)
                  </Typography>
                  <TextField
                    variant="outlined"
                    type="number"
                    fullWidth
                    value={tipoDeCambio}
                    onChange={(e) => {
                      const nuevoCambio = parseFloat(e.target.value) || 1;
                      setTipoDeCambio(nuevoCambio);

                      const subtotal = items.reduce((acc, item) => {
                        const precio = parseFloat(item.precioUnitario);
                        const cant = parseFloat(item.cantidad);
                        if (isNaN(precio) || isNaN(cant)) return acc;
                        return acc + precio * cant;
                      }, 0);

                      const totalConvertido = subtotal * nuevoCambio;

                      setImporteTotal(formatearImporte(totalConvertido));

                      setState((prev) => ({
                        ...prev,
                        importeTotal: totalConvertido.toFixed(2), // o redondeado como prefieras
                      }));
                    }}
                    // disabled={!editable || (!checkField(osDetails, "estadoOS", 5) && !checkField(osDetails, "estadoOS", 4)) || [2, 3, 5].includes(usuarioLocal.es_admin)}
                    // disabled={!editable || (!checkField(osDetails, "estadoOS", 5) && !checkField(osDetails, "estadoOS", 4))}
                    disabled={!editable}
                  />
                </div>

                <div style={{ width: "32%" }}>
                  <Typography style={{ marginBottom: 4 }} variant="subtitle1">
                    Divisa {checkField(osDetails, "estadoOS", 2) && <span className="text-danger">*</span>}
                  </Typography>
                  <Select
                    variant="outlined"
                    fullWidth
                    defaultValue=""
                    value={state.tipoMoneda || ""}
                    onChange={handleTipoMonedaChange}
                    // disabled={(!editable || !checkField(osDetails, "estadoOS", 5) && !checkField(osDetails, "estadoOS", 1)) || usuarioLocal.es_admin === 3}
                    disabled={(!editable || !checkField(osDetails, "estadoOS", 5) && !checkField(osDetails, "estadoOS", 1))}
                    error={!!errors.tipoMoneda}
                  >
                    <MenuItem value="">Seleccionar tipo</MenuItem>
                    <MenuItem value="Divisa">Divisa</MenuItem>
                    {/* <MenuItem value="Billete">Billete</MenuItem> */}
                  </Select>
                  {errors.tipoMoneda && (
                    <Typography color="error" variant="body2">
                      {errors.tipoMoneda}
                    </Typography>
                  )}
                </div>
              </>
            )}

          <div className={classes.conceptoField}>
            <div
              style={{ display: "flex", alignItems: "center", marginBottom: 4 }}
            >
              <Typography variant="subtitle1" style={{ marginRight: 4 }}>
                Importe total
              </Typography>
              <Tooltip
                title={
                  <span style={{ fontSize: "0.8rem" }}>
                    {currency === "USD"
                      ? "Este valor es la suma total del precio total de todos los items * el tipo de cambio"
                      : "Este valor es la suma total del precio total de todos los items"}
                  </span>
                }
              >
                <InfoIcon
                  fontSize="small"
                  style={{ color: "rgba(0, 0, 0, 0.54)" }}
                />
              </Tooltip>
            </div>
            <TextField
              variant="outlined"
              fullWidth
              value={importeTotal}
              InputProps={{ readOnly: true }}
              disabled
            />
          </div>
        </div>
        {checkField(osDetails, "estadoOS", 4) && (
          <>
            <div className={classes.observacionRechazo}>
              <Typography variant="subtitle1">
                Observación del rechazo
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                value={state.observacionRechazo || "Sin observación"}
                InputProps={{ readOnly: true }}
                disabled
              />
            </div>
            <br></br>
          </>
        )}
        {/* Área blanca con botones Adjuntar y Nuevo */}
        <div className={classes.areaBlanca}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="subtitle1" className={classes.itemText}>
              Items
            </Typography>
          </div>

          {/* Mostrar la tabla y los botones solo cuando se haga click en "Nuevo" */}
          {items.length > 0 && (
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Nombre</TableCell>
                    <TableCell align="center">Cantidad</TableCell>
                    <TableCell align="center">Precio unitario</TableCell>
                    <TableCell align="center">Precio total</TableCell>
                    {canDeleteItems && <TableCell align="center">Opciones</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {item.itemName ?? "Sin nombre"}
                      </TableCell>
                      <TableCell align="center">{item.cantidad ?? 0}</TableCell>
                      <TableCell align="center">
                        {formatearImporte(item.precioUnitario) ?? 0}
                      </TableCell>
                      <TableCell align="center">
                        {formatearImporte(
                          item.cantidad * item.precioUnitario
                        ) ?? 0}
                      </TableCell>
                      {canDeleteItems && (
                        <TableCell align="center">
                          <Tooltip title={<span style={{ fontSize: "0.8rem" }}>Editar</span>}>
                            <IconButton
                              size="small"
                              onClick={() => handleEditarItem(item, index)}
                            >
                              <EditIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={<span style={{ fontSize: "0.8rem" }}>Eliminar</span>}>
                            <IconButton
                              size="small"
                              onClick={() => handleEliminarItem(item.idItemsOS, index)}
                            >
                              <DeleteIcon color="secondary" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <AgregarItemsModal
            open={openItemsModal}
            onClose={handleCloseItemsModal}
            onGuardarItem={handleGuardarItem}
            resetFormulario={false}
            initialItem={itemModalData}
          />
        </div>
        <br />
        {/* {!isAdministracion && ( */}
        <div className={classes.areaBlanca}>
          <div className={classes.sectionHeader}>
            <Typography variant="subtitle1" className={classes.itemText}>
              Seguimiento
            </Typography>
            <div style={{ display: "flex", alignItems: "end" }}>
              {/* {(editable && !isAdministracion) && ( */}
              {(editable || isGeneral) && (
                <BotonGenerico
                  tipo="nuevo"
                  color="primary"
                  onClick={handleOpenSeg}
                  text="Nuevo"
                />
              )}
            </div>
            <ModalSeguimiento
              open={openSeg}
              ordenServicio={OS}
              onSuccess={handleSuccessSeguimiento}
              handleClose={handleCloseSegSeguimiento}
              usuarioLocal={usuarioLocal}
            />
          </div>

          {seguimiento.length > 0 && (
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ width: "20%" }}>
                      Fecha
                    </TableCell>
                    <TableCell align="center" style={{ width: "20%" }}>
                      Usuario
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        width: "50%",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                    >
                      Observaciones
                    </TableCell>
                    <TableCell align="center" style={{ width: "15%" }}>
                      Acciones
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {seguimiento
                    .filter(
                      (s) =>
                        !s.esInformeLaboratorio &&
                        !s.esComprobanteTransferencia
                    )
                    .map((row, index) => (
                      <TableRow key={`servicio-${index}`}>
                        <TableCell align="center" style={{ width: "20%" }}>
                          {row.fechaInicio}
                        </TableCell>
                        <TableCell align="center" style={{ width: "20%" }}>
                          {row.usuario}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            width: "50%",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                          }}
                        >
                          {row.observaciones ?? "Sin observaciones"}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                            {/* Mostrar botón Eliminar para Admin, General, Transferencia y Director */}
                            {/* {editable && ( */}
                            {editable && (isAdmin || isGeneral || isTransferencia || isDirector) && (
                              <Tooltip
                                title={
                                  <span style={{ fontSize: "0.8rem" }}>
                                    Eliminar
                                  </span>
                                }
                              >
                                <IconButton
                                  size="small"
                                  onClick={() => handleEliminarSeguimiento(row.idseguimientoOS, index)}
                                >
                                  <DeleteIcon color="secondary" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {seguimiento.some(s => s.esInformeLaboratorio) && (
            <div style={{ display: "flex", gap: "8px", marginTop: "16px", justifyContent: "flex-end" }}>
              <BotonGenerico
                tipo="adjuntar"
                text="Ver informe"
                onClick={() => {
                  const informe = seguimiento.find(s => s.esInformeLaboratorio);
                  if (informe) {
                    if (informe.adjunto) {
                      handleVerArchivo(informe.adjunto);
                    } else if (informe.archivoFile) {
                      const url = URL.createObjectURL(informe.archivoFile);
                      window.open(url, "_blank");
                      setTimeout(() => URL.revokeObjectURL(url), 1000);
                    }
                  }
                }}
                color="secondary"
                disabled={!seguimiento.some(s => s.esInformeLaboratorio)}
              />
              {/* {editable && (isAdmin || isGeneral || isTransferencia || isDirector) && ( */}
              {editable && (
                <BotonGenerico
                  tipo="eliminar"
                  text="Eliminar informe"
                  onClick={() => {
                    const informe = seguimiento.find(s => s.esInformeLaboratorio);
                    if (informe) {
                      const index = seguimiento.findIndex(s => s.esInformeLaboratorio);
                      handleEliminarSeguimiento(informe.idseguimientoOS, index);
                    }
                  }}
                  color="secondary"
                  disabled={!seguimiento.some(s => s.esInformeLaboratorio)}
                />
              )}
            </div>
          )}
        </div>
        {/* )} */}
        {(isAdmin || isAdministracion) && (
          <>
            <br />
            <div className={classes.areaBlanca}>
              <div className={classes.sectionHeader}>
                <Typography variant="subtitle1" className={classes.itemText}>
                  Comprobantes
                </Typography>
                <div style={{ display: "flex", alignItems: "end" }}>
                  {/* {editable && (isAdmin || isAdministracion) && ( */}
                  {editable && (
                    <>
                      <BotonGenerico
                        tipo="adjuntar"
                        text="Adjuntar"
                        onClick={handleAdjuntoClick}
                        color="primary"
                      />
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        accept=".pdf"
                      />

                      <BotonGenerico
                        tipo="nuevo"
                        text="Nuevo"
                        onClick={handleOpenComprobante}
                        color="primary"
                      />
                    </>
                  )}
                </div>
                <IngresarComprobanteModal
                  open={openComprobante}
                  comprobanteSelected={comprobanteSelected}
                  onClose={handleCloseComprobante}
                  onSuccess={handleSuccessComprobante}
                  usuarioLocal={usuarioLocal}
                  tipoComprobante={tipoComprobante}
                  OS={OS}
                  editable={editable}
                />
              </div>
              {comprobantes.length > 0 && (
                <TableContainer
                  component={Paper}
                  className={classes.tableContainer}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" style={{ width: "5%" }}>
                          Estado
                        </TableCell>
                        <TableCell align="center" style={{ width: "20%" }}>
                          Fecha del comprobante
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          Importe
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          Tipo de comprobante
                        </TableCell>
                        <TableCell align="center" style={{ width: "30%" }}>
                          Observación
                        </TableCell>
                        {mostrarColumnaReferencia && (
                          <TableCell align="center" style={{ width: "20%" }}>
                            Nro Ref. Pago
                          </TableCell>
                        )}
                        {mostrarColumnaOpciones && (
                          <TableCell align="center" style={{ width: "20%" }}>
                            Opciones
                          </TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {comprobantes.map((row, index) => (
                        <TableRow key={`comprobante-${index}`}>
                          <TableCell align="center" style={{ width: "5%" }}>
                            {renderEstadoIcon(row.estado)}
                          </TableCell>
                          <TableCell align="center" style={{ width: "20%" }}>
                            {row.fechaComprobante || "-"}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.importe || "-"}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {renderTipoComprobante(row.idTipoComprobante)}
                          </TableCell>
                          <TableCell align="center" style={{ width: "30%" }}>
                            {row.observaciones || "-"}
                          </TableCell>
                          {mostrarColumnaReferencia && (
                            <TableCell align="center" style={{ width: "20%" }}>
                              {row.nroReferenciaPago || "-"}
                            </TableCell>
                          )}
                          {mostrarColumnaOpciones && (
                            <TableCell align="center">
                              <Tooltip
                                title={
                                  <span style={{ fontSize: "0.8rem" }}>
                                    {row.esAdjunto ? "Ver adjunto" : "Ver"}
                                  </span>
                                }
                              >
                                <IconButton
                                  onClick={() => {
                                    if (row.esAdjunto) {
                                      const tieneInfoAdicional = row.cuit || row.sucursal || row.numero;
                                      if (tieneInfoAdicional) {
                                        setComprobanteSelected(row);
                                        handleOpenComprobante();
                                      } else {
                                        if (row.adjunto) {
                                          handleVerArchivo(row.adjunto);
                                        }
                                        if (row.archivoFile) {
                                          const url = URL.createObjectURL(row.archivoFile);
                                          window.open(url, "_blank");
                                          setTimeout(() => URL.revokeObjectURL(url), 10000);
                                        }
                                      }
                                    } else {
                                      setComprobanteSelected(row);
                                      handleOpenComprobante();
                                    }
                                  }}
                                >
                                  <SearchIcon color="primary" />
                                </IconButton>
                              </Tooltip>

                              {/* {editable && (isAdmin || isAdministracion) && row.estado !== "Firmado" && ( */}
                              {editable && row.estado !== "Firmado" && (
                                <Tooltip
                                  title={
                                    <span style={{ fontSize: "0.8rem" }}>
                                      Firmar comprobante
                                    </span>
                                  }
                                >
                                  <IconButton
                                    onClick={() => firmarComprobante(row, index)}
                                  >
                                    <AssignmentTurnedInIcon color="primary" />
                                  </IconButton>
                                </Tooltip>
                              )}
                              {/* {editable && (isAdmin || isAdministracion) && ( */}
                              {editable && (
                                <Tooltip
                                  title={
                                    <span style={{ fontSize: "0.8rem" }}>
                                      Eliminar
                                    </span>
                                  }
                                >
                                  <IconButton
                                    onClick={() =>
                                      handleOpenEliminarComprobante(
                                        row.idcomprobanteOS,
                                        index
                                      )
                                    }
                                  >
                                    <DeleteIcon color="secondary" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </div>
          </>
        )}
        {(isAdmin || isAdministracion) && (
          <>
            <br />
            <div className={classes.areaBlanca}>
              <div className={classes.sectionHeader}>
                <Typography variant="subtitle1" className={classes.itemText}>
                  Comprobante de transferencia
                </Typography>
                <div style={{ display: "flex", alignItems: "end", gap: 8 }}>
                  {/* {editable && (isAdmin || isAdministracion) && ( */}
                  {editable && (
                    <BotonGenerico
                      tipo="adjuntar"
                      text={seguimiento.some(s => s.esComprobanteTransferencia) ? "Reemplazar" : "Adjuntar"}
                      onClick={handleComprobanteTransferenciaClick}
                      color="primary"
                    />
                  )}
                  <input
                    type="file"
                    ref={comprobanteTransferenciaInputRef}
                    style={{ display: "none" }}
                    onChange={handleAdjuntarComprobanteTransferencia}
                    accept=".pdf"
                  />
                </div>
              </div>

              {seguimiento.some(s => s.esComprobanteTransferencia) && (
                <div style={{ marginTop: "16px" }}>
                  <div style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #e0e0e0",
                    borderRadius: 4,
                    padding: "12px",
                    marginBottom: "12px",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr auto",
                    gap: "12px",
                    alignItems: "center"
                  }}>
                    <div>
                      <Typography variant="caption" style={{ color: "#999", fontSize: "0.75rem" }}>
                        Cargado por
                      </Typography>
                      <Typography variant="body2">
                        {seguimiento.find(s => s.esComprobanteTransferencia)?.usuario || "-"}
                      </Typography>
                    </div>
                    <div>
                      <Typography variant="caption" style={{ color: "#999", fontSize: "0.75rem" }}>
                        Fecha
                      </Typography>
                      <Typography variant="body2">
                        {seguimiento.find(s => s.esComprobanteTransferencia)?.fechaInicio || "-"}
                      </Typography>
                    </div>
                    <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                      <Tooltip title={<span style={{ fontSize: "0.8rem" }}>Ver adjunto</span>}>
                        <IconButton
                          size="small"
                          onClick={() => {
                            const comprobante = seguimiento.find(s => s.esComprobanteTransferencia);
                            if (comprobante) {
                              if (comprobante.adjunto) {
                                handleVerArchivo(comprobante.adjunto);
                              } else if (comprobante.archivoFile) {
                                const url = URL.createObjectURL(comprobante.archivoFile);
                                window.open(url, "_blank");
                                setTimeout(() => URL.revokeObjectURL(url), 10000);
                              }
                            }
                          }}
                          color="primary"
                        >
                          <SearchIcon />
                        </IconButton>
                      </Tooltip>
                      {/* {editable && (isAdmin || isAdministracion) && ( */}
                      {editable && (
                        <Tooltip title={<span style={{ fontSize: "0.8rem" }}>Eliminar</span>}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              const comprobante = seguimiento.find(s => s.esComprobanteTransferencia);
                              if (comprobante) {
                                const index = seguimiento.findIndex(s => s.esComprobanteTransferencia);
                                handleOpenEliminarComprobanteTransferencia(comprobante.idseguimientoOS, index);
                              }
                            }}
                            color="secondary"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        <Dialog
          open={openEliminarComprobante}
          onClose={handleCloseEliminarComprobante}
        >
          <DialogTitle disableTypography>
            <Typography variant="h6" className={classes.titleText}>
              Confirmar eliminación
            </Typography>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleCloseEliminarComprobante}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            ¿Está seguro de que quiere eliminar este comprobante?
          </DialogContent>
          <DialogFooter>
            <BotonGenerico
              tipo="guardar"
              text="Confirmar"
              onClick={handleConfirmarEliminarComprobante}
              color="primary"
            />
            <BotonGenerico
              tipo="cancelar"
              text="Cancelar"
              onClick={handleCloseEliminarComprobante}
              color="secondary"
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          open={openEliminarComprobanteTransferencia}
          onClose={handleCloseEliminarComprobanteTransferencia}
        >
          <DialogTitle disableTypography>
            <Typography variant="h6" className={classes.titleText}>
              Confirmar eliminación
            </Typography>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleCloseEliminarComprobanteTransferencia}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            ¿Está seguro de que quiere eliminar este comprobante de transferencia?
          </DialogContent>
          <DialogFooter>
            <BotonGenerico
              tipo="guardar"
              text="Confirmar"
              onClick={handleConfirmarEliminarComprobanteTransferencia}
              color="primary"
            />
            <BotonGenerico
              tipo="cancelar"
              text="Cancelar"
              onClick={handleCloseEliminarComprobanteTransferencia}
              color="secondary"
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          open={openObservacion}
          onClose={() => {
            setObservacionRechazo("");
            setOpenObservacion(false);
          }}
        >
          <DialogTitle disableTypography>
            <Typography variant="h6" style={{ textAlign: "center" }}>
              Confirmar cancelación
            </Typography>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={() => {
                setObservacionRechazo("");
                setOpenObservacion(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Typography variant="subtitle1">
              ¿Está seguro de que desea rechazar este OS?
            </Typography>
            <br></br>
            <div className={classes.field}>
              <Typography variant="subtitle2">Observación</Typography>
              <TextField
                variant="outlined"
                multiline
                rows={3}
                fullWidth
                value={observacionRechazo}
                onChange={(e) => setObservacionRechazo(e.target.value)}
              />
            </div>
          </DialogContent>
          <DialogFooter>
            <div className={classes.actions}>
              <BotonGenerico
                tipo="guardar"
                text="Confirmar rechazo"
                onClick={() => {
                  handleGuardar(4);
                  setObservacionRechazo("");
                  setOpenObservacion(false);
                }}
                color="primary"
              />
              <BotonGenerico
                tipo="cancelar"
                text="Cancelar"
                onClick={() => {
                  setObservacionRechazo("");
                  setOpenObservacion(false);
                }}
                color="secondary"
              />
            </div>
          </DialogFooter>
        </Dialog>

        <FirmaComprobanteModal
          open={openFirma}
          onClose={() => setOpenFirma(false)}
          onSubmit={handleFirmaSubmit}
        />
      </DialogContent>

      <DialogFooter>
        {/* Botones de acción */}
        <div className={classes.actions}>
          {editable && (
            <BotonGenerico
              tipo="guardar"
              text="Guardar cambios"
              onClick={() => handleGuardar(osDetails?.estadoOS)}
            />
          )}

          {/* {checkField(osDetails, "estadoOS", 1) && ( */}
          {(isGeneral || isAdmin) && checkField(osDetails, "estadoOS", 1) && (
            <>
              <BotonGenerico
                tipo="adjuntar"
                text={seguimiento.some(s => s.esInformeLaboratorio) ? "Reemplazar informe de laboratorio" : "Adjuntar informe de laboratorio"}
                onClick={handleInformeClick}
                color="primary"
                disabled={false}
              />
              <input
                type="file"
                ref={informeInputRef}
                style={{ display: "none" }}
                onChange={handleAdjuntarInforme}
                accept=".pdf"
              />
              {seguimiento.some(s => s.archivoFile) && (
                <BotonGenerico
                  tipo="aprobar"
                  text="Enviar a Transferencia"
                  onClick={() => handleGuardar(5)}
                />
              )}
            </>
          )}

          {/* {(isTransferencia || isAdmin) && checkField(osDetails, "estadoOS", 5) && ( */}
          {checkField(osDetails, "estadoOS", 5) && (
            <BotonGenerico
              tipo="guardar"
              text="Aceptar"
              onClick={() => handleGuardar(6)}
            />
          )}

          {/* {(isTransferencia || isAdmin) && checkField(osDetails, "estadoOS", 5) && ( */}
          {checkField(osDetails, "estadoOS", 5) && (
            <BotonGenerico
              tipo="rechazar"
              text="Rechazar"
              onClick={handleModalObservacion}
              color="secondary"
            />
          )}

          {/* {(isDirector || isAdmin) && checkField(osDetails, "estadoOS", 6) && ( */}
          {checkField(osDetails, "estadoOS", 6) && (
            <BotonGenerico
              tipo="aprobar"
              text="Mandar Envío Cliente"
              onClick={() => handleGuardar(7)}
            />
          )}

          {/* {(isDirector || isAdmin) && checkField(osDetails, "estadoOS", 6) && ( */}
          {checkField(osDetails, "estadoOS", 6) && (
            <BotonGenerico
              tipo="rechazar"
              text="Rechazar"
              onClick={handleModalObservacion}
              color="secondary"
            />
          )}

          {/* {(isAdmin || isAdministracion) && checkField(osDetails, "estadoOS", 7) && (
            <BotonGenerico
              tipo="adjuntar"
              text="Descargar informe"
              onClick={() => {
                const informe = seguimiento.find((s) => s.esInformeLaboratorio);
                if (informe?.adjunto) {
                  handleVerArchivo(informe.adjunto);
                } else if (informe?.archivoFile) {
                  const url = URL.createObjectURL(informe.archivoFile);
                  window.open(url, "_blank");
                  setTimeout(() => URL.revokeObjectURL(url), 1000);
                }
              }}
              disabled={!seguimiento.some((s) => s.esInformeLaboratorio)}
            />
          )} */}

          {/* {(isAdmin || isAdministracion) && checkField(osDetails, "estadoOS", 7) && ( */}
          {checkField(osDetails, "estadoOS", 7) && (
            <BotonGenerico
              tipo="guardar"
              text="Marcar finalizado"
              onClick={() => handleGuardar(3)}
            />
          )}

          {/* {(isAdmin || isAdministracion) && checkField(osDetails, "estadoOS", 7) && ( */}
          {checkField(osDetails, "estadoOS", 7) && (
            <BotonGenerico
              tipo="rechazar"
              text="Rechazar"
              onClick={handleModalObservacion}
              color="secondary"
            />
          )}

          {/* {(isGeneral || isAdmin) && checkField(osDetails, "estadoOS", 4) && ( */}
          {checkField(osDetails, "estadoOS", 4) && (
            <BotonGenerico
              tipo="aprobar"
              text="Reenviar a aprobación"
              onClick={() => handleGuardar(1)}
            />
          )}
        </div>
      </DialogFooter>
    </Dialog>
  );
};

export default OrdenServicios;
